
studentapp = {
 
  ajaxContainer:$('main'),
  getContent:function(hash){
    studentapp.ajaxContainer.removeClass('loaded').empty();
    hash = hash.replace(/\#/g, ' ');
    $.get(hash, function(data){
       var content = $(data).find('.ajax_container')
       studentapp.ajaxContainer.html(content).addClass('loaded');
       
    });
  },
}

ajaxStore = "";

//hash change
$(function(){
  if(window.location.hash){
    studentapp.getContent(window.location.hash) 
  }else{
    studentapp.ajaxContainer.addClass('loaded');
  }
});

$(window).hashchange(function(e, data) {
  studentapp.getContent(data.after);
});


//SIDE BAR 
$(document).on('click','.has_dropdown',function(e){
  e.preventDefault();
  var t = $(this);
  $('.student_nav_modules_dropdown').slideUp(200);
  if(t.hasClass('active')){
    t.removeClass('active');
  }else{
    $('.has_dropdown').removeClass('active');
    t.addClass('active').next('.student_nav_modules_dropdown').slideDown(200)
  };
});

$(document).on('click','.menu_icon',function(e){
  e.preventDefault();
  var t = $(this),
      menu = $('.student_nav nav');
  if(t.hasClass('open')){
    t.removeClass('open');
    menu.removeClass('open');
  }else{
    t.addClass('open');
    menu.addClass('open');
  };
});

